import Vue from "vue";

let startDate = new Date();
startDate.setHours(0, 0, 0, 0);

let endDate = new Date();
endDate.setHours(23, 59, 59, 0);

export const filterStore = Vue.observable({
    dateRange: {
        startDate: startDate,
        endDate: endDate
    },

    selectedRoomNames: [],
    selectedUsers: [],
});

export const filterMutations = {

    setDateRange(dateRange) {
        filterStore.dateRange = dateRange;
    },

    setSelectedRoomNames(roomNames) {
        filterStore.selectedRoomNames = roomNames;
    },

    setSelectedUsers(users) {
        filterStore.selectedUsers = users;
    }

};

export const filterGetters = {

    getSelectedUserIdsAsString() {
        return filterStore.selectedUsers.map(obj => obj.value).join(',');
    }
}